import { all, fork } from 'redux-saga/effects';
import fetch from './fetch';
import toggleReminder from './toggleReminder';

export default function* dashboard() {
  yield all([fork(fetch)]);
  yield all([fork(toggleReminder)]);
}
